import React, { FunctionComponent } from 'react';
import { FormLabel, FormErrorMessage, Checkbox, FormControl, Stack } from '@chakra-ui/react';


export interface CheckboxParams {
    id: string
    title: string
    message: string | null
    value: boolean
    visible: boolean
    disabled?: boolean
}

interface CheckboxProps {
    id: string
    title: string
    message: string | null
    value: boolean
    disabled?: boolean
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void

}


const BtCheckbox: FunctionComponent<CheckboxProps> = ({ id, title, message, value, onChange , disabled}) => {

    return (<>
        <FormControl isInvalid={message !== ''} isDisabled={disabled}>
            <Stack w='full' spacing={5} direction={['row', 'row']} >
                <Checkbox isDisabled={disabled} id={id} name={id} onChange={(event) => onChange(event)} checked={value} defaultChecked={value} />
                <FormLabel htmlFor={id}>{title}</FormLabel>
                <FormErrorMessage>{message}</FormErrorMessage>
            </Stack>
        </FormControl>
    </>
    )

}

export default BtCheckbox;